export function getPostInitialValues() {
  return {
  };
}

const VALIDATION_SCHEMA = () => {
}
export { VALIDATION_SCHEMA };
